import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { toast } from "sonner";
import { loginAdmin, getMe } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("pitstop_token")) return;
    getMe().then(() => nav("/admin/dashboard")).catch(() => localStorage.removeItem("pitstop_token"));
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await loginAdmin(email, password);
      localStorage.setItem("pitstop_token", token);
      toast.success("Sikeres bejelentkezés");
      nav("/admin/dashboard");
    } catch (err) {
      const d = err?.response?.data?.detail || "Hibás adatok";
      toast.error(typeof d === "string" ? d : "Bejelentkezési hiba");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#050508] text-white grid place-items-center p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-10 h-10 grid place-items-center rounded-sm bg-gradient-to-br from-blue-600 to-violet-600 glow-blue">
              <span className="font-display font-bold">PT</span>
            </div>
            <div className="text-left">
              <div className="font-display font-bold text-lg">PITSTOP TIRE</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-violet-300/80">Admin</div>
            </div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="border border-white/10 bg-[#0A0A0F] p-7 rounded-sm space-y-4" data-testid="admin-login-form">
          <h1 className="font-display font-black text-2xl uppercase tracking-tight">Bejelentkezés</h1>
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-white/50 mb-1 font-bold">E-mail</label>
            <input
              data-testid="admin-email"
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 bg-white/[0.03] border border-white/10 rounded-sm text-white focus:outline-none focus:border-violet-400 text-base"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-white/50 mb-1 font-bold">Jelszó</label>
            <input
              data-testid="admin-password"
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 bg-white/[0.03] border border-white/10 rounded-sm text-white focus:outline-none focus:border-violet-400 text-base"
              autoComplete="current-password"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-gradient-to-r from-blue-600 to-violet-600 hover:from-blue-500 hover:to-violet-500 text-white font-bold text-sm uppercase tracking-wider rounded-sm glow-blue inline-flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
            Belépés
          </button>
        </form>
      </div>
    </main>
  );
}
